/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon24Regular = forwardRef('MathDeltaIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.882 3.28c.904-1.695 3.332-1.695 4.236 0l8.1 15.188c.853 1.599-.305 3.53-2.117 3.53H3.899c-1.811 0-2.97-1.931-2.117-3.53l8.1-15.189Zm.542 2.688a1 1 0 0 1 1.76 0l6.955 12.915a1 1 0 0 1-.88 1.475H4.349a1 1 0 0 1-.88-1.475l6.955-12.915Z" })));
});
